import { apiPath } from "@/api/api-path"
import axios from "axios"
import qs from "qs"
import store from "@/store/index"
import api from "./service"

axios.defaults.timeout = 15000

let tokenForExternal

function setTokenFromVuex() {
  tokenForExternal = store.state.appPermission.token
}

export async function getUsersMeByUsername(username) {
  setTokenFromVuex()
  return axios
    .get(apiPath.getUsersMeByUsername, {
      headers: {
        Authorization: "Bearer " + tokenForExternal, //the token is a variable which holds the token
      },
      params: {
        username,
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function updateDepartmentList(data) {
  return api
    .put(apiPath.updateDepartmentList, data)
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getStaffList() {
  return api
    .get(apiPath.getStaffList)
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getStaffListV2(filter) {
  return api
    .get(apiPath.getStaffListV2, {
      params: {
        ...filter,
      },
      paramsSerializer: (params) => {
        return qs.stringify(params)
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function getAllStaffList(filter) {
  return api
    .get(apiPath.getAllStaffList, {
      params: {
        ...filter,
      },
      paramsSerializer: (params) => {
        return qs.stringify(params)
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function authentication(loginData) {
  return api
    .post(apiPath.authentication, loginData)
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      throw error
    })
}

export async function getUserPermissions(userToken) {
  return axios
    .get(apiPath.getUserPermissions, {
      headers: {
        Authorization: "Bearer " + userToken,
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      throw error
    })
}

export async function checkIsInternalTokenAvailable(internalToken) {
  return axios
    .get(apiPath.checkIsTokenAvailable, {
      headers: {
        Authorization: "Bearer " + internalToken, //the token is a variable which holds the token
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      throw error
    })
}

export async function checkIsCustomerTokenAvailable(customerToken) {
  return axios
    .get(apiPath.checkIsTokenAvailable, {
      headers: {
        Authorization: "Bearer " + customerToken, //the token is a variable which holds the token
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      throw error
    })
}

export async function internalChangePassword(newPasswordData) {
  return api
    .post(apiPath.changePassword, newPasswordData)
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      throw error
    })
}

export async function externalChangePassword(newPasswordData) {
  setTokenFromVuex()
  return axios
    .post(apiPath.changePassword, newPasswordData, {
      headers: {
        Authorization: "Bearer " + tokenForExternal, //the token is a variable which holds the token
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      throw error
    })
}

export async function getCustomerPermission() {
  const path = apiPath.getCustomerPermission
  return api
    .get(path, {})
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      console.error(error)
    })
}

export async function updateCustomerPermission(customerPermission) {
  const path = apiPath.updateCustomerPermission
  return api
    .put(path, customerPermission, {})
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      throw error
    })
}

export async function updateProfile(data) {
  return api
    .put(apiPath.updateProfile, data)
    .then((response) => {
      if (response.status === 200) return response.data
    })
    .catch((error) => {
      throw error
    })
}

export async function getUserList(filter) {
  return api
    .get(apiPath.getUserList, {
      params: filter,
      paramsSerializer: (params) => {
        return qs.stringify(params)
      },
    })
    .then((response) => {
      if (response.status === 200) return response.data.data
    })
    .catch((error) => {
      console.error(error)
    })
}
